import z from 'zod';
import { isBoolean, isString } from '@fxts/core';

/**
 * @example ```
 * CoerceToBooleanSchema.parse('true'); // true
 * CoerceToBooleanSchema.parse('false'); // false
 *
 * CoerceToBooleanSchema.parse(true); // true
 * CoerceToBooleanSchema.parse(false); // false
 *
 * CoerceToBooleanSchema.parse('t'); // throw Error
 * ```
 */
export const CoerceToBooleanSchema = z.union([z.string(), z.boolean()]).transform((val) => {
  if (isBoolean(val)) {
    return val;
  }
  if (isString(val)) {
    if (val === 'true') return true;
    if (val === 'false') return false;
  }
});
